import { ResponseError } from '@/dmdrive/core/service/FetchService';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong.';
export const UNAUTHORIZED_ERROR_MESSAGE = 'Unauthorized.';

export class AppError {
  error: Error | string = DEFAULT_ERROR_MESSAGE;
  description?: string;

  constructor(error?: Nullable<Error | string>, description?: Nullable<string>) {
    if (error) {
      this.error = error;
    }

    if (description) {
      this.description = description;
    }
  }

  get message() {
    if (this.error instanceof Error) {
      return this.error?.message;
    }

    return this.error;
  }

  get code() {
    return (this.error as ResponseError)?.status ?? 0;
  }
}
